export const STICKER_PACKS = [
  {
    id: 'essentials',
    name: 'Essentials',
    stickers: [
      { id: 'sparkles', glyph: '✦', label: 'Sparkles', color: '#f59e0b' },
      { id: 'heart', glyph: '♥', label: 'Heart', color: '#f43f5e' },
      { id: 'star', glyph: '★', label: 'Star', color: '#8b5cf6' },
      { id: 'smile', glyph: '☺', label: 'Smile', color: '#f97316' },
      { id: 'flower', glyph: '✿', label: 'Flower', color: '#ec4899' },
      { id: 'bolt', glyph: '⚡', label: 'Bolt', color: '#0ea5e9' },
    ],
  },
  {
    id: 'calls-to-action',
    name: 'Callouts',
    stickers: [
      { id: 'new', glyph: 'NEW', label: 'New', color: '#ef4444', kind: 'label' },
      { id: 'shop', glyph: 'SHOP', label: 'Shop', color: '#059669', kind: 'label' },
      { id: 'listen', glyph: 'LISTEN', label: 'Listen', color: '#7c3aed', kind: 'label' },
      { id: 'watch', glyph: 'WATCH', label: 'Watch', color: '#db2777', kind: 'label' },
      { id: 'arrow', glyph: '↘', label: 'Arrow', color: '#0f172a' },
      { id: 'circle', glyph: '◌', label: 'Circle', color: '#14b8a6' },
    ],
  },
];

export const STICKERS = STICKER_PACKS.flatMap((pack) => pack.stickers);

export const getSticker = (id) => STICKERS.find((sticker) => sticker.id === id) || STICKERS[0];

const clamp = (value, min, max, fallback) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? Math.min(max, Math.max(min, numeric)) : fallback;
};

export const normalizeDecorations = (value) => {
  if (!Array.isArray(value)) return [];

  return value.slice(0, 12).map((item, index) => ({
    id: String(item?.id || `decoration-${index}`),
    kind: item?.kind === 'image' && /^https:\/\//i.test(String(item?.src || '')) ? 'image' : 'sticker',
    asset: getSticker(item?.asset).id,
    src: item?.kind === 'image' && /^https:\/\//i.test(String(item?.src || '')) ? String(item.src) : '',
    x: clamp(item?.x, 3, 97, 50),
    y: clamp(item?.y, 3, 97, 20),
    width: clamp(item?.width, 8, 42, 16),
    rotation: clamp(item?.rotation, -180, 180, 0),
    zIndex: Math.round(clamp(item?.zIndex, 1, 20, index + 1)),
    opacity: clamp(item?.opacity, 0.2, 1, 1),
    actionUrl: /^https?:\/\//i.test(String(item?.actionUrl || '')) ? String(item.actionUrl) : '',
    tooltip: String(item?.tooltip || '').slice(0, 50),
  }));
};

export const createStickerDecoration = (asset, index = 0) => ({
  id: typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `sticker-${Date.now()}-${index}`,
  kind: 'sticker',
  asset: getSticker(asset).id,
  x: 72,
  y: Math.min(82, 16 + index * 9),
  width: 16,
  rotation: index % 2 ? -10 : 8,
  zIndex: index + 1,
  opacity: 1,
});

export const createImageDecoration = (src, index = 0) => ({
  ...createStickerDecoration('sparkles', index),
  kind: 'image',
  src,
  width: 24,
  rotation: 0,
});
